import { render, staticRenderFns } from "./productDetailAppraise.vue?vue&type=template&id=3adcafa1&scoped=true"
import script from "./productDetailAppraise.vue?vue&type=script&lang=js"
export * from "./productDetailAppraise.vue?vue&type=script&lang=js"
import style0 from "./productDetailAppraise.vue?vue&type=style&index=0&id=3adcafa1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3adcafa1",
  null
  
)

export default component.exports